import React from 'react';
import PropTypes from 'prop-types';
import RAULogo from './RAU-Logo.jpg';
import RAULogo2x from './RAU-Logo-2x.jpg';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(
  {
    root: {
      width: 80,
    },
  },
  { name: 'CompanyLogo' }
);

export const CompanyLogo = ({ className }) => {
  const classes = useStyles();
  return (
    <img srcSet={`${RAULogo2x} 2x`} src={RAULogo} alt="RAU Logo" className={clsx(classes.root, className)} />
  );
};

CompanyLogo.propTypes = {
  className: PropTypes.string,
};

export default CompanyLogo;
